import { Clear } from "@mui/icons-material";
import { Box, Button, Chip } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { useGetLocale } from "@refinedev/core";
import { LabelInfo } from "./createFilterStore";
import { useFiltersWithContext } from "./filter-context/useFiltersWithContext";

export const SearchIndicators = () => {
  const {
    filters: filterRecords,
    deleteFilter,
    clearFilters,
  } = useFiltersWithContext();

  const getLocale = useGetLocale();
  const locale = getLocale();

  const { translate } = useTranslation();

  const filters = useMemo(
    () => Object.values(filterRecords).filter((filter) => !!filter.labelInfo),
    [filterRecords]
  );

  const getLabelFromInfo = (info?: LabelInfo) => {
    if (!info) return null;

    let field = translate(info.descriptionKey);
    let value = info.value;

    if (info.isValueDate && info.value) {
      value = new Date(info.value).toLocaleDateString(locale);
    }

    if (info.isValueTranslated && info.value) {
      value = translate(info.value);
    }

    if (info.descriptionSuffixKey) {
      field += " " + translate(info.descriptionSuffixKey);
    }

    let result = field;
    if (value) {
      result += `: ${value}`;
    }

    return result;
  };

  if (filters.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        margin: "8px 0",
        padding: "8px 16px",
        width: "100%",
        backgroundColor: (theme) => theme.palette.customBackground.box,
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {filters.map((filter) => (
          <Chip
            key={filter.field + filter.operator}
            label={getLabelFromInfo(filter.labelInfo)}
            variant="outlined"
            onDelete={() => deleteFilter(filter.field, filter.operator)}
          />
        ))}
      </Box>
      <Box>
        <Button
          variant="outlined"
          color="error"
          size="small"
          startIcon={<Clear fontSize="small" />}
          onClick={clearFilters}
        >
          {translate("buttons.clear")}
        </Button>
      </Box>
    </Box>
  );
};
